import React from 'react';
import { Star } from 'lucide-react';
import { cx } from '@/lib/format';

export const Stars = ({ value = 0, size = 14, className = '' }) => {
  const full = Math.floor(value);
  const half = value - full >= 0.5;
  return (
    <div className={cx('flex items-center', className)} aria-label={`Rated ${value} out of 5`}>
      {[0, 1, 2, 3, 4].map((i) => {
        const active = i < full || (i === full && half);
        return (
          <Star
            key={i}
            size={size}
            className={active ? 'fill-[hsl(var(--gaze-gold))] text-[hsl(var(--gaze-gold))]' : 'text-muted-foreground/40'}
          />
        );
      })}
    </div>
  );
};

export default Stars;
